module.exports = __webpack_public_path__ + "static/media/trash-icon-red.b6a73955.png";